const INACTIVITY_TIMEOUT = 24 * 60 * 60 * 1000;
const ACTIVITY_KEY = 'user_last_activity';

const recordActivity = (): void => {
  const timestamp = Date.now();
  localStorage.setItem(ACTIVITY_KEY, timestamp.toString());
};

const getLastActivity = (): number => {
  return Number(localStorage.getItem(ACTIVITY_KEY)) || Date.now();
};

const isActive = (): boolean => {
  const lastActivity = getLastActivity();
  return Date.now() - lastActivity < INACTIVITY_TIMEOUT;
};

const clearActivity = (): void => {
  localStorage.removeItem(ACTIVITY_KEY);
};

export const userActivity = {
  recordActivity,
  getLastActivity,
  isActive,
  clearActivity,
};

export default userActivity;
